import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import InputAddExp from 'components/IncorporationOfTerms/Register/FormAtoms/InputAddExp';
import PhoneNumberHookForm from './PhoneNumberHookForm';

export const MobileForm = ({ disabled }) => {
  const { employeeVo } = useSelector(state => state.account);

  return (
    <>
      <TblRow>
        <TblRowHeader rowHeader="MB_T_PHONE" />
        <TblRowTail unUsedInputBox guideText={<InputAddExp textLabel="MB_T_CATION_PHONE" />}>
          <PhoneNumberHookForm name="mphonNo" disabled={disabled} values={employeeVo?.mphonNo} />
        </TblRowTail>
      </TblRow>
    </>
  );
};
MobileForm.propTypes = { disabled: PropTypes.bool };
MobileForm.defaultProps = { disabled: false };
export default MobileForm;
